import { isDevelopmentMode } from '../../utils/helpers';

export default function useDevelopmentMode() {
  const isDev = isDevelopmentMode();
  return isDev;
}
